import IMAGE_SIZES from 'constants/imageSizes';

const { medium4x5 } = IMAGE_SIZES;

const base = {
  fallbackDims: medium4x5,
  sourceSets: []
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
